import { TextField } from '@change/ds-forms';

// This component is very similar to apps/front-end/src/app/shared/components/payments/components/NameInput/index.tsx
// the copy is needed to accommodate the different styling coming with this experiment.
// If the experiment will be productized, we need to refactor the code to avoid duplication.
export function NameInput({
	firstName,
	lastName,
	name,
	disabled,
	validationErrors,
	useSplitFields,
	labelName,
	labelFirstName,
	labelLastName,
	setFirstName,
	setLastName,
	setName,
	trackNameInputFocus,
	trackFirstNameInputFocus,
	trackLastNameInputFocus,
}: {
	firstName: string;
	lastName: string;
	name: string;
	disabled: boolean;
	validationErrors: Record<string, string> | null;
	useSplitFields: boolean;
	labelName: string;
	labelFirstName: string;
	labelLastName: string;
	setFirstName: (firstName: string) => void;
	setLastName: (lastName: string) => void;
	setName: (name: string) => void;
	trackNameInputFocus: () => void;
	trackFirstNameInputFocus: () => void;
	trackLastNameInputFocus: () => void;
}): React.JSX.Element {
	if (useSplitFields)
		return (
			<div className="flex items-start gap-3">
				<div className="flex-1">
					<TextField
						name="input-first-name"
						errorMessage={validationErrors?.firstName}
						isInvalid={!!validationErrors?.firstName}
						validationBehavior="aria"
						label={labelFirstName}
						onChange={(e) => setFirstName(e)}
						onFocus={() => trackFirstNameInputFocus()}
						type="text"
						value={firstName}
						data-qa="input-first-name"
						id="cardholder-firstName-input"
						isDisabled={disabled}
					/>
				</div>

				<div className="flex-1">
					<TextField
						name="input-last-name"
						errorMessage={validationErrors?.lastName}
						isInvalid={!!validationErrors?.lastName}
						validationBehavior="aria"
						label={labelLastName}
						onChange={(e) => setLastName(e)}
						onFocus={() => trackLastNameInputFocus()}
						type="text"
						value={lastName}
						data-qa="input-last-name"
						id="cardholder-lastName-input"
						isDisabled={disabled}
					/>
				</div>
			</div>
		);

	return (
		<div className="flex items-end gap-2">
			<div className="flex-grow">
				<TextField
					name="input-cardholder-name"
					errorMessage={validationErrors?.name}
					isInvalid={!!validationErrors?.name}
					validationBehavior="aria"
					label={labelName}
					onChange={(e) => setName(e)}
					onFocus={() => trackNameInputFocus()}
					type="text"
					value={name}
					data-qa="input-cardholder-name"
					id="cardholder-name-input"
					isDisabled={disabled}
				/>
			</div>
		</div>
	);
}
